import { JSX } from 'react';
import { Icon, WidgetIconProps } from './widget-icon';

export type PortalIconProps = Omit<WidgetIconProps, 'icon'>

export namespace PortalIcons {
  export const Administration = (props?: PortalIconProps): JSX.Element => <Icon icon="Cog" {...props} />;
  export const Management = (props?: PortalIconProps): JSX.Element => <Icon icon="Spanner" {...props} />;
  export const Tracking = (props?: PortalIconProps): JSX.Element => <Icon icon="MapPin" {...props} />;
  export const Help = (props?: PortalIconProps): JSX.Element => <Icon icon="Help" {...props} />;
  export const Support = (props?: PortalIconProps): JSX.Element => <Icon icon="ExternalLink" {...props} />;
}
